export enum ObjectLayer {
  Head = "Head",
  Title = "Title",
  Content = "Content",
  SubContent = "SubContent",
  Group = "Group",
  Asset = "Asset",
  Clip = "Clip",
}
